const Driver = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/index.vue'
  )

const CreateDriver = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/create.vue'
  )

const EditDriver = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/edit.vue'
  )

const DetailDriver = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/detail.vue'
  )

const AcceptOrder = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/accept-order.vue'
  )

const Approve = () =>
  import(
    /* webpackChunkName: "transport-driver" */ '@/pages/transport/driver/approve.vue'
  )

export default {
  path: 'driver',
  meta: {
    label: 'driver',
    auth: 'driver'
  },
  component: {
    name: 'Driver',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'DriverReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Driver
    },
    {
      name: 'CreateDriver',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateDriver
    },
    {
      name: 'EditDriver',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditDriver,
      props: true
    },
    {
      name: 'DetailDriver',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailDriver,
      props: true
    },
    {
      name: 'DriverAcceptOrder',
      path: 'accept-order/:id',
      meta: {
        title: 'users.acceptShipment',
        auth: true
      },
      component: AcceptOrder,
      props: true
    },
    {
      name: 'DriverApprove',
      path: 'approve/:id',
      meta: {
        title: 'cms.approve'
      },
      component: Approve,
      props: true
    }
  ]
}
